import { onMounted, onUnmounted, type Ref, watchEffect } from 'vue';

declare global {
    interface JQuery {
        modal(command: string): JQuery;
    }
}

export const useBootstrapModal = (modalRootEl: Ref<HTMLElement | undefined>, toggleRef: Ref<boolean>) => {
    const hideModal = () => {
        toggleRef.value = false;
    };

    onMounted(() => {
        // clicking on the modal mask triggers an event that should close the modal
        jQuery(modalRootEl.value!).on('hidden.bs.modal', hideModal);
    });

    onUnmounted(() => {
        jQuery(modalRootEl.value!).off('hidden.bs.modal', hideModal);
    });

    // programmatically toggle the Bootstrap modal when `toggleRef` changes
    watchEffect(() => {
        if (modalRootEl.value) {
            jQuery(modalRootEl.value).modal(toggleRef.value ? 'show' : 'hide');
        }
    });
};
